import { ZonesApiResponse, zonesApiResponseSchema } from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export const getAllZones = async (siteId?: string): Promise<ZonesApiResponse> => {
	const params = new URLSearchParams({ noPagination: 'true' });
	if (siteId) params.set('selectedSiteId', siteId);
	const { body } = await clientRequest.get(`/api/zones?${params.toString()}`, { schema: zonesApiResponseSchema });
	return body;
};
